import LeafMoleculeIcon from './LeafMoleculeIcon'

export default LeafMoleculeIcon
